window.uniqid = (function(){var id=new Date().getTime();return function() {return id++;}})();

require('./helpers.js');
require('./ckeditor_builder.js');

require('@claviska/jquery-ajaxSubmit/jquery.ajaxSubmit.js');


// 	
// 	  ##   ####  #     ####   ##  #####         ##         #  #        ##
// 	 #  #  #     #     #     #  #   #          #  #        #  #         #
// 	 #     #     #     #     #      #             #        #  #   ##    #    ###    ##   # ##   ###
// 	  ##   ###   #     ###   #      #            #         ####  #  #   #    #  #  #  #  ##    #
// 	    #  #     #     #     #      #           #          #  #  ####   #    #  #  ####  #      ##
// 	 #  #  #     #     #     #  #   #          #           #  #  #      #    #  #  #     #        #
// 	  ##   ####  ####  ####   ##    #          ####        #  #   ##   ###   ###    ##   #     ###
// 	                                                                         #
// 	                                                                         #

var select2_term = '';

function select2_getAllIndexes(searchStr, str, caseSensitive) {
    var searchStrLen = searchStr.length;
    if (searchStrLen == 0) {
        return [];
    }
    var startIndex = 0, index, indices = [];
    if (!caseSensitive) {
        str = str.toLowerCase();
        searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
}

function select2_highlight_term(searchStr, str) {
	str = str;
	var indexes = select2_getAllIndexes(searchStr, str, false);
	var length = searchStr.length;
	for(var i=indexes.length-1;i>=0;i--)
	{
		var index = indexes[i];
		var a = str.slice(0,index);
		var b = str.slice(index,index+length);
		var c = str.slice(index+length);
		str = a+'<em class="select2-item-term-highlight">'+b+'</em>'+c;
	};
	return str;
}

function select2_format (state) {
	return state.text ? $('<span>'+select2_highlight_term(select2_term, state.text)+'</span>') : null;
};

function select2_matcher(params, data) {
	var term = $.trim(params.term).toLowerCase();
	select2_term = term;

    // If there are no search terms, full list
    if (term === '') {
      return data;
    }
    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined') {
      return null;
    }

    // `params.term` should be the term that is used for searching
    // `data.text` is the text that is displayed for the data object
    if (data.text.toLowerCase().indexOf(term) > -1) {
      var modifiedData = $.extend({}, data, true);
      return modifiedData;
    }

    // Return `null` if the term should not be displayed
    return null;
}

// 	
// 	  ##                           #                        #           #
// 	 #  #                          #            #                             #
// 	 #  #  ###    ##          ###  ###    ##   ####        ##    ###   ##    ####
// 	 #  #  #  #  #  #        #     #  #  #  #   #           #    #  #   #     #
// 	 #  #  #  #  ####         ##   #  #  #  #   #           #    #  #   #     #
// 	 #  #  #  #  #              #  #  #  #  #   #           #    #  #   #     #
// 	  ##   #  #   ##         ###   #  #   ##     ##        ###   #  #  ###     ##
// 	
// 	

$(document).ready(function ()
{
	$('.selectFontawesome').select2(
		{
			templateResult:function(state) {
				if (!state.id)
					return state.text;
				return $('<span><i class="fa fa-2x fa-'+state.element.value+'" style="color:#d94c3f;margin-right:0.25em;width:1.2em;text-align:center;vertical-align: middle;"></i> '+state.element.value+'</span>');
			},
			templateSelection:function(state) {
				if (!state.id)
					return state.text;
				return $('<span><i class="fa fa-'+state.element.value+'" style="color:#d94c3f;margin-right:0.25em;width:1.2em;text-align:center;vertical-align: middle;"></i> '+state.element.value+'</span>');
			}
		}
	);

	if($("input.color-picker").length)
	{
		var colorPickerBgUpdate = function(el,c)
		{
			var color = require('color'); // https://www.npmjs.com/package/color
			$(el).css({'backgroundColor':c,'color':(color(c).isLight() ? '#000':'#fff')});
		}

		$("input.color-picker")
			// colorpicker option => see https://itsjavi.com/bootstrap-colorpicker/
			.colorpicker({
			})
			.each(function(){
				if($(this).val())
					colorPickerBgUpdate(this,$(this).val());
				else
					colorPickerBgUpdate(this, 'rgba(0,0,0,0)');
			})
			.on('changeColor', function(e) {
				if(e.color.origFormat==null)
					colorPickerBgUpdate(this, 'rgba(0,0,0,0)');
				else
					colorPickerBgUpdate(this, e.color.toString('rgba'));
			});
	}

	$("input:radio").each(function(){

		if($(this).data('toogle')!=undefined)
		{
			$(this).bind('click change',function(){
				//console.debug('input[name='+$(this).attr('name')+']');
				var name = $(this).attr('name').replace(/(\[|\])/g,'\\\\$1');
				var els = $('input[name='+name+']');
				//console.debug(els);
				for(var i=0; i<els.length; i++)
				{
					if(els.eq(i).is(':checked'))
						$(els.eq(i).data('toogle')).show();
					else
						$(els.eq(i).data('toogle')).hide();
				}
			});
			if($(this).is(':checked'))
				$(this).trigger('click');
		}
	});

	// -------------------------------------------------------------------------------------

	$( ".datepicker" ).datepicker({
		dateFormat:'yy-mm-dd',
		showButtonPanel: true,
		changeMonth: true,
		changeYear: true,
		numberOfMonths: 1
	});

	// -------------------------------------------------------------------------------------

	$('input[type=file].filepicker').each(function(){
		var id = $(this).attr('id');
		var name = $(this).attr('name');
		var label = $(this).attr('label');

		if(!id) { id = uniqid(); $(this).attr('id',id); }

		var button = $('<button type="button" '
				+'class="filepicker btn btn-small btn-primary" '
				+'id="button_'+id+'" '
				+'data-id="'+id+'" '
				+'data-name="'+name+'">'
				+'<i class="fa fa-upload" style="color:#fff;"></i>'
				+label
			+'</button>');

		button.on('click.filepicker',function(e){
				e.preventDefault();
				var id = $(this).data('id');
				var name = $(this).data('name');

				if(!$(this).data('called'))
				{
					var input = $('<input type="file" style="display:none;" id="'+id+'" name="'+name+'">')
					input.on('change.filepicker',function(){
						var id = $(this).attr('id');
						$('#button_'+id).addClass('btn-success').html('<i class="fa fa-upload" style="color:#fff;"></i> '+$(this).val());
					});
					$(this).after(input);
				}
				$('#'+id).trigger('click')
				return false;
			});
		$(this).after(button);
		$(this).remove();
	});

	// -------------------------------------------------------------------------------------

	if($('.nav-tabs').length>0)
	{
		var hash = getHash();
		$('.nav-tabs a[data-toggle="tab"][href="#'+hash+'"]').tab('show')

		$('.nav-tabs').each(function(){
			var btn = $(this).find('a[data-toggle="tab"][href="#'+hash+'"]');
			if(btn.length>0)
				btn.tab('show');
			else
				$(this).find('a[data-toggle="tab"]').eq(0).tab('show');
		})
		$('.nav-tabs a').on('click',function(e){
			var href = $(this).attr('href');
			if(/^#\w+/.test(href))
			{
				//e.preventDefault();
				setHash(href);
			}
			window.HAPI_RefreshOnReveal();
		});
		$(window).bind('hashchange',refreshHash);

		$('.nav-tabs a[data-toggle="tab"]').on('click',function(){
			$(this).parents('.nav-tabs').find('li.active').removeClass('active');
		})
	}

	$("[rel=tooltip]").tooltip({html:true});

	$(".jsPopover").each(function(){
		var $this = $(this);
		$this
			.popover({
				offset: 10,
				html:true,
				placement:$this.attr('data-placement') ? $this.attr('data-placement'):'above'
			})
			.click(function(e) {
				//console.debug($(this).attr('data-placement'));
				e.preventDefault()
			});
	});

	$('.fancybox').fancybox({
		type : 'iframe',
		iframe : {
			preload: false,
			css : {
				maxWidth:'1200px',
				width : '100%',
				height : '100%' // avoid javascript rewrite (width bad calculation)
			}
		}
	});

	setTimeout(function(){
		CKEDITOR_Build(document);
	},500)


	$('form.ajaxSubmit').append('<input type="hidden" name="ajaxSubmit" value="1">');
	$('form.ajaxSubmit').ajaxSubmit({
		loader: '.ajaxSubmit-form-loader',
		after: function(res) { setTimeout(function(el){ $(el).find('.ajaxSubmit-form-indicator').hide(); }.bind(null,this), 2000); },
		before: function() {
			$(this).find('.ajaxSubmit-form-indicator').hide();
			$(this).find('.ajaxSubmit-form-loader').show();
			for(var instanceName in CKEDITOR.instances)
				CKEDITOR.instances[instanceName].updateElement();
		},
		error: function(res) {
			$(this).find('.ajaxSubmit-form-indicator').hide();
			$(this).find('.ajaxSubmit-form-error').show();
		},
		success: function(res) {
			$(this).find('.ajaxSubmit-form-indicator').hide();
			$(this).find('.ajaxSubmit-form-success').show();
		}
	});

	setTimeout(function(){
		var pipe = getHashPipe();
		if(pipe && $('#'+pipe).length>0)
		{
			hash = getHash();
			setHash(hash);
			$('html,body').scrollTop($('#'+pipe).offset().top);
		}
	},200)

	if(typeof(pageLoaded)=='function')
		pageLoaded();
});


var HAPI_RefreshOnReveal_delay = null;
window.HAPI_RefreshOnReveal = function() {
	clearTimeout(HAPI_RefreshOnReveal_delay);
	// apply ui initialisation when dom element are revealed or enter in the viewport area
	HAPI_RefreshOnReveal_delay = setTimeout(function(){
		CKEDITOR_Build(document);
		window.dispatchEvent(new Event('resize'));
		HAPI_RefreshOnReveal_delay = setTimeout(function(){
			try { HapimapLoader.resetAll(); } catch(e) {};
		},100);
	},100);
}


//
// 	  ##         ##                   #                    ###           ##                    #           ####                           #
// 	 #  #         #                   #         #          #  #         #                      #           #                        #
// 	 #  #  ###    #     ##    ###   ###         #          #  #   ##    #    # ##   ##    ###  ###         #     #  #  ###    ###  ####  ##     ##   ###
// 	 #  #  #  #   #    #  #  #  #  #  #       #####        ###   #  #  ###   ##    #  #  #     #  #        ###   #  #  #  #  #      #     #    #  #  #  #
// 	 #  #  #  #   #    #  #  #  #  #  #         #          # #   ####   #    #     ####   ##   #  #        #     #  #  #  #  #      #     #    #  #  #  #
// 	 #  #  #  #   #    #  #  # ##  #  #         #          #  #  #      #    #     #        #  #  #        #     #  #  #  #  #      #     #    #  #  #  #
// 	  ##   #  #  ###    ##    # #   ###                    #  #   ##    #    #      ##   ###   #  #        #      ###  #  #   ###    ##  ###    ##   #  #
//
//

window.HAPI_RefreshJavascriptBehaviors_FunctionStack = new Set();

window.HAPI_RefreshJavascriptBehaviors = function(parentElement=null) {

	// handle external behaviors stacks
	for(var func of window.HAPI_RefreshJavascriptBehaviors_FunctionStack)
	{
		if(typeof func === "function")
		{
			func(parentElement);
		}
	}

	// add all things needed to be refreshed after the original onload Event
	// eg. in case of HTML partial ajax loading

	$('[data-toggle="popover"]').popover({
		container: 'body'
	})
	$('[data-toggle="tooltip"]').tooltip();

	$('[data-toggle="confirmation"]').confirmation({
		rootSelector: '[data-toggle=confirmation]',
		container:'body',
		singleton:true,
		popout:true,
		btnOkClass:'btn-success',
		btnCancelClass:'btn-danger',
		// other options if needed
	});

	function multipleSorter(data) {

		let selected = data.filter(item => item.selected)
		let unselected = data.filter(item => !item.selected).sort((a, b) => a.id.localeCompare(b.id))
        // inversé ce tableau afficherai les options sélectionné en haut et éviterai d'avoir le scroll a l'ouverture tout en bas de la liste
		return [...unselected, ...selected]
		}

	$("select.select2, input.select2")
		.not('.select2-ready')
		.addClass('select2-ready').each(function(){
			var options = {
				//dropdownAutoWidth:true,
				matcher: select2_matcher,
				templateResult : select2_format,
				escapeMarkup: function(m) { return m; }
			};
			if($(this).data('tags')){
				options.tags = $(this).data('tags');
			}
			let isMultiple = $(this).attr('multiple')
			if (isMultiple) {
				options.sorter= multipleSorter;
			}
			let $select2 = $(this).select2(options);

			if (isMultiple) {
				$select2.on('select2:select', function(e){
					$(this).append($(e.params.data.element)).trigger("change");
				});
			}
		});

	// select2 jquery focus bug fix
	// https://github.com/select2/select2/issues/5993
	$(document).on('select2:open', (event) => {
		var sf = $(event.target).siblings('.select2-container').find('.select2-search__field')
		sf = sf.length>0 ? sf : $(document).find('.select2-search__field');
		//console.log(sf);
		if(sf.length>0)
			sf[0].focus();
	});

	try { HapimapLoader.resetAll(); } catch(e) {};
}

window.HAPI_Add_RefreshJavascriptBehaviors = function(func)
{
	window.HAPI_RefreshJavascriptBehaviors_FunctionStack.add(func);
}


$(document).ready(window.HAPI_RefreshJavascriptBehaviors);